import React, { createContext, useContext, useEffect, useState } from "react";
import { appUser,setAppUser,clearAppUser,appToken,clearAppToken,setAppToken } from "../../../utils/storageHelper";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  // Initialize from localStorage (so refresh keeps you logged in)
   const [user, setUser] = useState(appUser());
  const [token, setToken] = useState(appToken());

  

  const login = (userData, authToken) => {
    setUser(userData);
    setToken(authToken);
    setAppUser(userData);
    setAppToken(authToken);
  };

   const logout = () => {
    setUser(null);
    setToken(null);
    clearAppUser();
    clearAppToken();
  };

  // Keep multiple tabs in sync
  useEffect(() => {
    const onStorage = (e) => {
      if (e.key === "app.user") {
        setUser(e.newValue ? JSON.parse(e.newValue) : null);
      }
      if (e.key === "app.token") {
        setToken(e.newValue);
      }
    };
    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  }, []);

  return (
    <AuthContext.Provider value={{ user, token, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
